import baseAPI from './axiosApi'

const api={
    page:'/api-u/menus/tree',
    add:'/api-u/menus',
    update:'/api-u/menus',
    delete:'/api-u/menus/',
    menusMe:'/api-u/menus/me'
}
//获取菜单列表
export function getPermissionTree (parameter) {
    return baseAPI.axiosData(api.page, 'get', parameter)
}
//新增菜单
export function addPermission (parameter) {
    return baseAPI.axiosData(api.add,'post',parameter)
}
//编辑菜单
export function updatePermission (parameter) {
    return baseAPI.axiosData(api.update,'put',parameter)
}
//删除菜单
export function removePermission (id) {
    return baseAPI.axiosData(api.delete+id,'delete')
}
//获取用户拥有权限的菜单树
export function menusMe (id) {
    if(id=='')
    {
        return baseAPI.axiosData(api.menusMe,'get')
    }
    else
    {
        return baseAPI.axiosData(api.menusMe+'?parentId='+id,'get')
    }
}